module.exports = __webpack_public_path__ + "__static/site-1784740481084/img/ant-star3.7d43b76b.png";